(function (root, factory) {
  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  root.PremiottVitrinaSchedule = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  var TIME_ZONE = 'Europe/Bucharest';
  var OPEN_HOUR = 12;
  var WEEKDAYS = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 };
  var formatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: TIME_ZONE,
    weekday: 'short',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
  });

  function partsAt(date) {
    var values = {};

    formatter.formatToParts(date).forEach(function (part) {
      if (part.type !== 'literal') {
        values[part.type] = part.value;
      }
    });

    return {
      year: Number(values.year),
      month: Number(values.month),
      day: Number(values.day),
      hour: Number(values.hour),
      minute: Number(values.minute),
      second: Number(values.second),
      weekday: WEEKDAYS[values.weekday],
    };
  }

  function addCalendarDays(parts, days) {
    var value = new Date(Date.UTC(parts.year, parts.month - 1, parts.day + days));

    return {
      year: value.getUTCFullYear(),
      month: value.getUTCMonth() + 1,
      day: value.getUTCDate(),
    };
  }

  function localTimeToUtc(calendarDate, hour, minute) {
    var target = Date.UTC(calendarDate.year, calendarDate.month - 1, calendarDate.day, hour, minute, 0);
    var guess = new Date(target);

    for (var index = 0; index < 4; index += 1) {
      var shown = partsAt(guess);
      var shownAsUtc = Date.UTC(
        shown.year,
        shown.month - 1,
        shown.day,
        shown.hour,
        shown.minute,
        shown.second
      );
      guess = new Date(guess.getTime() + target - shownAsUtc);
    }

    return guess;
  }

  function isOpenParts(parts) {
    if (parts.weekday >= 5) return true;
    if (parts.weekday === 4) return parts.hour >= OPEN_HOUR;
    return false;
  }

  function stateAt(date, override) {
    if (override === 'force_open') return 'open';
    if (override === 'force_results') return 'results';

    return isOpenParts(partsAt(date)) ? 'open' : 'results';
  }

  function isSealed(date) {
    var parts = partsAt(date);

    return parts.weekday === 4 && parts.hour < OPEN_HOUR;
  }

  function nextTransition(date) {
    var parts = partsAt(date);

    if (isOpenParts(parts)) {
      var daysToMonday = (8 - parts.weekday) % 7;
      if (daysToMonday === 0) daysToMonday = 7;

      return localTimeToUtc(addCalendarDays(parts, daysToMonday), 0, 0);
    }

    var daysToThursday = (4 - parts.weekday + 7) % 7;

    return localTimeToUtc(addCalendarDays(parts, daysToThursday), OPEN_HOUR, 0);
  }

  function remaining(date) {
    var totalSeconds = Math.max(0, Math.round((nextTransition(date).getTime() - date.getTime()) / 1000));

    return {
      totalSeconds: totalSeconds,
      days: Math.floor(totalSeconds / 86400),
      hours: Math.floor((totalSeconds % 86400) / 3600),
      minutes: Math.floor((totalSeconds % 3600) / 60),
    };
  }

  return {
    TIME_ZONE: TIME_ZONE,
    OPEN_HOUR: OPEN_HOUR,
    stateAt: stateAt,
    isSealed: isSealed,
    nextTransition: nextTransition,
    remaining: remaining,
  };
});
